module.exports = __webpack_public_path__ + "img/co.3fcbe0e.png";